"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_FEATURED_CONTENT_FOR_GUEST_QUERY = void 0;
const client_1 = require("@apollo/client");
exports.GET_FEATURED_CONTENT_FOR_GUEST_QUERY = (0, client_1.gql) `
  query GetFeaturedContentForGuest {
    featuredContent {
      id
      title
      displayOrder
      featuredItems {
        id
        image {
          url
          accessibilityText
        }
        title
        description
        linkType
        displayOrder
      }
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZWRDb250ZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vY29tcG9uZW50cy9HdWVzdC9fX3F1ZXJpZXNfXy9mZWF0dXJlZENvbnRlbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMkNBQXFDO0FBRXhCLFFBQUEsb0NBQW9DLEdBQUcsSUFBQSxZQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FtQnRELENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBncWwgfSBmcm9tIFwiQGFwb2xsby9jbGllbnRcIjtcblxuZXhwb3J0IGNvbnN0IEdFVF9GRUFUVVJFRF9DT05URU5UX0ZPUl9HVUVTVF9RVUVSWSA9IGdxbGBcbiAgcXVlcnkgR2V0RmVhdHVyZWRDb250ZW50Rm9yR3Vlc3Qge1xuICAgIGZlYXR1cmVkQ29udGVudCB7XG4gICAgICBpZFxuICAgICAgdGl0bGVcbiAgICAgIGRpc3BsYXlPcmRlclxuICAgICAgZmVhdHVyZWRJdGVtcyB7XG4gICAgICAgIGlkXG4gICAgICAgIGltYWdlIHtcbiAgICAgICAgICB1cmxcbiAgICAgICAgICBhY2Nlc3NpYmlsaXR5VGV4dFxuICAgICAgICB9XG4gICAgICAgIHRpdGxlXG4gICAgICAgIGRlc2NyaXB0aW9uXG4gICAgICAgIGxpbmtUeXBlXG4gICAgICAgIGRpc3BsYXlPcmRlclxuICAgICAgfVxuICAgIH1cbiAgfVxuYDtcbiJdfQ==